import { useCartStore } from "../store/use-cart-store";
import { useConfigStore } from "../store/use-config";
import { selectStandardBloodTestPackages, selectUpsellBloodTestPackages } from "../store/use-config/selectors";

export const useUpsellPackages = () => {
  const standardBloodTestPackages = useConfigStore(selectStandardBloodTestPackages);
  const upsellBloodTestPackages = useConfigStore(selectUpsellBloodTestPackages);
  const { getStandardProduct } = useCartStore();
  const standardProduct = getStandardProduct();
  const standardBloodTestPackage = standardBloodTestPackages.find((btp) => btp.uuid === standardProduct?.uuid);

  const upsellBloodTestPackagesBasedOnStandardProduct = standardBloodTestPackage?.upsellBloodTestPackageUuids
    ?.map((uuid) => upsellBloodTestPackages.find((btp) => btp.uuid === uuid))
    ?.filter(Boolean)
    ?.sort((a, b) => (a?.position ?? 0) - (b?.position ?? 0));

  return {
    upsellBloodTestPackagesBasedOnStandardProduct,
  };
};
